'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _list = require('./list');

var _list2 = _interopRequireDefault(_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

String.prototype.unCapitalize = function unCapitalize() {
  return this.charAt(0).toLowerCase() + this.slice(1);
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _state$ownProps$model = state[ownProps.model.unCapitalize()],
      _state$ownProps$model2 = _state$ownProps$model.all,
      data = _state$ownProps$model2.data,
      isLoading = _state$ownProps$model2.isLoading,
      pages = _state$ownProps$model2.pages,
      headers = _state$ownProps$model2.headers,
      total = _state$ownProps$model2.total,
      _state$ownProps$model3 = _state$ownProps$model.current,
      currentData = _state$ownProps$model3.data,
      currentIsLoading = _state$ownProps$model3.isLoading,
      error = _state$ownProps$model3.error,
      errorMessage = _state$ownProps$model3.errorMessage,
      _state$form = state.form,
      _state$form$forms = _state$form.forms,
      createForm = _state$form$forms[ownProps.model + '/post'],
      updateForm = _state$form$forms[ownProps.model + '/put'],
      formIsLoading = _state$form.isLoading,
      _state$filter = state.filter,
      filterForm = _state$filter.filters[ownProps.model],
      filterIsLoading = _state$filter.isLoading;


  var returnObject = {
    data: data,
    isLoading: isLoading,
    pages: pages,
    headers: headers,
    total: total,
    currentData: currentData,
    currentIsLoading: currentIsLoading,
    // default props
    createForm: createForm,
    updateForm: updateForm,
    formIsLoading: formIsLoading,
    // form props
    filterForm: filterForm,
    filterIsLoading: filterIsLoading,
    error: error,
    errorMessage: errorMessage
  };

  if (ownProps.addons && ownProps.addons.length) {
    var addonsArray = [];
    ownProps.addons.forEach(function (entry, index) {
      addonsArray[index] = {};
      addonsArray[index].data = state[entry.model.unCapitalize()].current.data;
      addonsArray[index].isLoading = state[entry.model.unCapitalize()].current.isLoading;
      addonsArray[index].error = state[entry.model.unCapitalize()].current.error;
      addonsArray[index].errorMessage = state[entry.model.unCapitalize()].current.errorMessage;
      addonsArray[index].form = state.form.forms[entry.model + '/put'];
      addonsArray[index].name = entry.name;
      addonsArray[index].model = entry.model;
    });
    returnObject.addonsArray = addonsArray;
  }

  return returnObject;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var actionCreators = {
    fetchForm: undefined.props.Models.Form.get,
    fetchFilter: undefined.props.Models.Filter.get,
    getAllData: undefined.props.Models[ownProps.model].all,
    getData: undefined.props.Models[ownProps.model].get,
    createData: undefined.props.Models[ownProps.model].create,
    updateData: undefined.props.Models[ownProps.model].update,
    deleteData: undefined.props.Models[ownProps.model].delete
  };

  if (ownProps.addons && ownProps.addons.length) {
    ownProps.addons.forEach(function (entry, index) {
      actionCreators['addons' + index + 'get'] = undefined.props.Models[entry.model].get;
      actionCreators['addons' + index + 'update'] = undefined.props.Models[entry.model].update;
    });
  }

  return Object.assign({}, (0, _redux.bindActionCreators)(actionCreators, dispatch));
};

var List = function List(props) {
  return props.list ? props.list(props) : _react2.default.createElement(_list2.default, props);
};

List.propTypes = {
  list: _propTypes2.default.func,
  actions: _propTypes2.default.array.isRequired,
  models: _propTypes2.default.object.isRequired
  // getAllData: PropTypes.func.isRequired,
  // headers: PropTypes.array,
  // data: PropTypes.array,
  // isLoading: PropTypes.bool,
  // total: PropTypes.number,
  // // end of list props

  // model: PropTypes.string.isRequired,
  // filter: PropTypes.bool,
  // scroll: PropTypes.number,
  // addonsArray: PropTypes.array,
  // name: PropTypes.string,
  // url: PropTypes.string,
  // customAddons: PropTypes.array,
  // list: PropTypes.func,
  // // end of component props

  // fetchForm: PropTypes.func.isRequired,
  // formIsLoading: PropTypes.bool,
  // // end of form props

  // fetchFilter: PropTypes.func.isRequired,
  // filterIsLoading: PropTypes.bool,
  // filterForm: PropTypes.object,
  // // end of filter props

  // createData: PropTypes.func.isRequired,
  // updateData: PropTypes.func.isRequired,
  // createForm: PropTypes.object,
  // updateForm: PropTypes.object,
  // getData: PropTypes.func.isRequired,
  // dataIsLoading: PropTypes.bool,
  // currentData: PropTypes.object,
  // // end of create update props
};

List.defaultProps = {
  //   headers: [],
  //   data: [],
  //   isLoading: false,
  //   total: 0,
  //   // end of list props

  //   filter: false,
  //   scroll: 1800,
  //   addonsArray: [],
  //   name: '',
  //   url: undefined,
  //   customAddons: [],
  list: undefined
  //   // end of component props

  //   formIsLoading: false,
  //   // end of form props

  //   filterIsLoading: false,
  //   filterForm: {},
  //   // end of filter props

  //   createForm: {},
  //   updateForm: {},
  //   dataIsLoading: false,
  //   currentData: {},
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(List);


//////////////////
// WEBPACK FOOTER
// ./node_modules/slide-new-toolkit/dist/List/index.js
// module id = 1044
// module chunks = 0